import React, { useState } from "react";

import axios from "axios";

import { Link, Navigate } from "react-router-dom";

import Auth from "./App/Auth";

const Login = () => {
  const image = {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "65%",
  };

  const [state, setState] = React.useState({
    loggedIn: false,
  });

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [svaed, setChecked] = useState("");

  const [emailErr, setEmailErr] = useState({});
  const [passwordErr, setPasswordErr] = useState({});

  const onSubmit = (b) => {
    b.preventDefault();
    const isValid = formValidation();
    //console.log("works");

    localStorage.setItem("email", "");
    localStorage.setItem("fullname", "");

    if (isValid) {
      const users = {
        email: email,
        password: password,
      };

      //console.log(users);

      axios({
        method: "post",
        url: "/auth/",
        data: users,
        config: { headers: { "Content-Type": "multiport/form-data" } },
      })
        .then(function (response) {
          //console.log(response);
          if (response.data.message === "success") {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("email", email);
            localStorage.setItem("Address", response.data.address);
            setState({
              loggedIn: true,
            });
          } else if (response.data.message === "exist") {
            localStorage.setItem("token_id", response.data.token);
          } else {
            setState({
              loggedIn: false,
              message: "Incorrect details used!. Try again!",
              alerts: "text-cemter fs-4 mt-3 mb-3 alert alert-danger",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const formValidation = () => {
    const emailErr = {};
    const passwordErr = {};
    let isValid = true;

    if (password.trim().length < 5) {
      passwordErr.passwordWrong = "Password is too short";
      isValid = false;
    }

    if (!password) {
      passwordErr.passwordWrong = "Password is required here";
      isValid = false;
    }

    if (!email) {
      emailErr.emailWrong = "Email is required here";
      isValid = false;
    }

    setEmailErr(emailErr);
    setPasswordErr(passwordErr);

    return isValid;
  };

  const Loggin = localStorage.getItem("token_id");

  if (Loggin) {
    return (
      <>
        <Auth />
      </>
    );
  } else if (state.loggedIn) {
    window.history.back();
    return <Navigate to={"/app"} />;
  } else {
    return (
      <div className="bg-light-gradient-bottom">
        <div class="container d-flex flex-column">
          <div class="row align-items-center justify-content-center g-0 min-vh-100">
            <div class="col-lg-5 col-md-8 py-6 py-xl-0">
              <div class="card shadow ">
                <div class="card-body p-6">
                  <div class="mb-4">
                    <Link to="/" className="ms-8 text-center">
                      <img
                        src="../assets/images/brand/logo/smfreelance-2.png"
                        className="mb-4 text-center"
                        width="260"
                        alt=""
                        style={image}
                      />
                    </Link>
                    <h1 class="mb-1 fw-bold">Sign in</h1>
                    <span>
                      Don’t have an account?{" "}
                      <Link to="/signup" class="ms-1">
                        Sign up
                      </Link>
                    </span>
                  </div>

                  <div class={state.alerts} role="alert">
                    {state.message}
                  </div>

                  <form onSubmit={onSubmit}>
                    <div className="mb-3">
                      <label for="name" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address"
                        onChange={(e) => {
                          setEmail(e.target.value);
                          emailErr.emailWrong = "";
                        }}
                      />
                      {Object.keys(emailErr).map((key) => {
                        return (
                          <div className="text-danger fs-5 mt-3">
                            {emailErr[key]}
                          </div>
                        );
                      })}
                    </div>

                    <div className="mb-3">
                      <label for="password" className="form-label">
                        Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        onChange={(e) => {
                          setPassword(e.target.value);
                          passwordErr.passwordWrong = "";
                        }}
                      />
                      {Object.keys(passwordErr).map((key) => {
                        return (
                          <div className="text-danger fs-5 mt-3">
                            {passwordErr[key]}
                          </div>
                        );
                      })}
                    </div>

                    <div class="d-lg-flex justify-content-between align-items-center mb-4">
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="rememberme"
                          value="save"
                          onChange={(e) => {
                            setChecked(e.target.value);
                          }}
                        />
                        <label class="form-check-label " for="rememberme">
                          Remember me
                        </label>
                      </div>
                      <div>
                        <Link to="../reset">Forgot your password?</Link>
                      </div>
                    </div>
                    <div>
                      <div class="d-grid">
                        <button type="submit" class="btn btn-primary ">
                          Sign in
                        </button>
                      </div>
                    </div>
                    <hr class="my-4" />
                    <div class="mt-4 text-center">
                      <a
                        href="https://t.me/+aO5rVEkmkJ5mNzBk" target="_blank"
                        class="btn-social btn-social-outline btn-facebook"
                      >
                        <i class="fab fa-telegram"></i>
                      </a>

                      <a
                        href="https://twitter.com/SmEduFreelance?s=09" target="_blank"
                        class="btn-social btn-social-outline btn-twitter"
                      >
                        <i class="fab fa-twitter"></i>
                      </a>

                      <a
                        href="https://www.instagram.com/smartedufreelance?r=nametag" target="_blank"
                        class="btn-social btn-social-outline btn-instagram"
                      >
                        <i class="fab fa-instagram"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Login;
